import { createRootRoute, Outlet } from '@tanstack/react-router';
import App from '@src/App';
import NotFound from '@pages/NotFound';
import RouteError from '@pages/RouteError/RouteError';
import ErrorLayout from '@pages/RouteError/ErrorLayout';

export const Route = createRootRoute({
  component: () => (
    <App>
      <Outlet />
    </App>
  ),
  errorComponent: (props) => (
    <ErrorLayout>
      <RouteError {...props} />
    </ErrorLayout>
  ),
  notFoundComponent: NotFound,
});
